/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Date_LabelInputs */



/**
* | output |
* | --- |
* | "Date" |
*
* @param {Promo_Movement_Date_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_date_label = /** @type {((inputs?: Promo_Movement_Date_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Date_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data")
	return /** @type {LocalizedString} */ ("Date")
});